import React, { useEffect } from "react";
import VendorDashbardStats from "./VendorDashbardStats";
import MediaEarning from "./MediaEarning";
import OngoingProjectStatus from "./OngoingProjectStatus";
import VendorDashboardNotification from "./VendorDashboardNotification";
import OngoingWork from "./OngoingWork";
import { useSelector, useDispatch } from "react-redux";
import { fetchVendorDashboard } from "../../../redux/slices/vendorDashboardSlice";
import CircularProgress from "@mui/material/CircularProgress";

const VendorDashboard = () => {
  const dispatch = useDispatch();

  const { loading, error } = useSelector((state) => state.vendorDashboard);

  // Dispatch thunk on component mount
  useEffect(() => {
    dispatch(fetchVendorDashboard());
  }, [dispatch]);

  // Optional: Show loading or error states
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-[60vh]">
        <CircularProgress />
        <p className="text-gray-600 text-sm">Please wait a few seconds...</p>
      </div>
    );
  }
  if (error) return <p className="text-red-500">Error: {error}</p>;

  return (
    <div className=" flex flex-col mr-2 gap-6">
      {/* Top header */}
      <div className="">
        <VendorDashbardStats />
      </div>

      {/* Main grid layout */}
      <div className="grid grid-cols-1 lg:grid-cols-[30%_70%] flex-grow gap-4">
        <div className="">
          <MediaEarning />
        </div>

        <div className="flex flex-col h-full gap-4">
          {/* Top section (2/3 height) with two equal columns */}
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <OngoingProjectStatus />
            </div>
            <div className="flex-1">
              <VendorDashboardNotification />
            </div>
          </div>

          {/* Bottom section (1/3 height) */}
          <div className=" flex-1">
            <OngoingWork />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDashboard;
